/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../styles/globals.css";
import "@/i18n"; // Initialize i18next before the app renders.
import GSAPProvider from "@/providers/gsapProvider";
import LoadingScreen from "@/components/LoadingScreen";

const RootComponent = () => {
	const [loadingDone, setLoadingDone] = useState(false);

	return (
		<React.StrictMode>
			<GSAPProvider>
				{!loadingDone ?
					<LoadingScreen
						minDisplayTime={500}
						onLoadingComplete={() => setLoadingDone(true)}
					/>
				:	<App />}
			</GSAPProvider>
		</React.StrictMode>
	);
};

ReactDOM.createRoot(document.getElementById("root")!).render(<RootComponent />);
